module.exports = __webpack_public_path__ + "static/media/clean6.a1d12700.jpg";